
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <section className="py-16 bg-gradient-to-br from-orange-600 to-orange-700">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Refund Policy</h1>
            <p className="text-lg text-white/90">
              Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </section>

        <section className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <div className="bg-orange-50 border-l-4 border-orange-600 p-6 mb-8 rounded-r-lg">
                <p className="text-sm text-gray-700 leading-relaxed">
                  At Digital Domination LLC, we are committed to delivering exceptional service and
                  results. This Refund Policy outlines the terms and conditions under which refunds
                  may be requested and processed.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-file-list-3-line text-orange-600 mr-3"></i>
                  General Policy
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed mb-4">
                  Digital Domination LLC offers refunds under specific circumstances as outlined in
                  this policy. All refund requests must be submitted in writing to{' '}
                  <a
                    href="mailto:domination@thompsondigital.org"
                    className="text-orange-600 hover:text-orange-700 font-medium"
                  >
                    domination@thompsondigital.org
                  </a>{' '}
                  and will be reviewed on a case-by-case basis.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-time-line text-orange-600 mr-3"></i>
                  Service-Specific Refund Terms
                </h2>

                <div className="space-y-6">
                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">
                      Digital Marketing Services
                    </h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Refund requests must be made within 30 days of service initiation
                        </span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Partial refunds may be issued based on work completed and resources
                          utilized
                        </span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          No refunds will be issued after 30 days or once campaign results are
                          delivered
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">SEO Services</h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          SEO services require a minimum commitment period as specified in your
                          service agreement
                        </span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Refunds may be considered if agreed-upon deliverables are not met within
                          the specified timeframe
                        </span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Results-based guarantees are subject to terms outlined in individual
                          service agreements
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">
                      Web Development Services
                    </h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Deposits are non-refundable once development work has commenced
                        </span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Refunds may be issued if project milestones are not met as per the agreed
                          timeline
                        </span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Client-requested changes or delays may affect refund eligibility
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-white border border-gray-200 rounded-lg p-6">
                    <h3 className="text-lg font-bold text-gray-900 mb-3">Consulting Services</h3>
                    <ul className="space-y-2 text-sm text-gray-700">
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Consulting fees are non-refundable once sessions have been conducted
                        </span>
                      </li>
                      <li className="flex items-start">
                        <i className="ri-checkbox-circle-line text-orange-600 mr-2 mt-0.5"></i>
                        <span>
                          Unused prepaid consulting hours may be refunded within 60 days of purchase
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-close-circle-line text-orange-600 mr-3"></i>
                  Non-Refundable Items
                </h2>
                <div className="bg-gray-50 rounded-lg p-6">
                  <ul className="space-y-2 text-sm text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Third-party advertising costs (Google Ads, Facebook Ads, etc.)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Domain registration and hosting fees</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Third-party software licenses and subscriptions</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Custom content creation (copywriting, graphic design, video)</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-arrow-right-s-line text-orange-600 mr-2 mt-0.5"></i>
                      <span>Setup and onboarding fees</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-file-text-line text-orange-600 mr-3"></i>
                  Refund Request Process
                </h2>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold text-sm">
                      1
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1 text-sm">Submit Request</h3>
                      <p className="text-sm text-gray-700">
                        Email your refund request to domination@thompsondigital.org with your
                        account details and reason for the request
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold text-sm">
                      2
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1 text-sm">Review Period</h3>
                      <p className="text-sm text-gray-700">
                        Our team will review your request within 5-7 business days
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold text-sm">
                      3
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1 text-sm">Decision</h3>
                      <p className="text-sm text-gray-700">
                        You will receive a written response regarding the approval or denial of your
                        refund request
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-600 text-white rounded-full flex items-center justify-center mr-4 flex-shrink-0 font-bold text-sm">
                      4
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-900 mb-1 text-sm">Processing</h3>
                      <p className="text-sm text-gray-700">
                        Approved refunds will be processed within 10-14 business days to the
                        original payment method
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-shield-check-line text-orange-600 mr-3"></i>
                  Satisfaction Guarantee
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed mb-4">
                  We stand behind the quality of our work. If you are not satisfied with our
                  services, we encourage you to contact us immediately so we can address your
                  concerns. We are committed to working with you to find a satisfactory resolution
                  before considering a refund.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-question-line text-orange-600 mr-3"></i>
                  Disputes and Chargebacks
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed mb-4">
                  We request that you contact us directly to resolve any billing disputes before
                  initiating a chargeback with your credit card company. Chargebacks filed without
                  prior communication may result in suspension of services and may affect future
                  business relationships.
                </p>
              </div>

              <div className="mb-10">
                <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-refresh-line text-orange-600 mr-3"></i>
                  Changes to This Policy
                </h2>
                <p className="text-sm text-gray-700 leading-relaxed mb-4">
                  Digital Domination LLC reserves the right to modify this Refund Policy at any
                  time. Changes will be effective immediately upon posting to our website. Your
                  continued use of our services after any changes constitutes acceptance of the new
                  policy.
                </p>
              </div>

              <div className="bg-gradient-to-r from-orange-600 to-orange-700 rounded-xl p-8 text-white">
                <h2 className="text-2xl font-bold mb-4">Questions About Our Refund Policy?</h2>
                <p className="text-sm mb-6 leading-relaxed">
                  If you have any questions or concerns about our refund policy, please don't
                  hesitate to contact us. We're here to help.
                </p>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-xl mr-3"></i>
                    <a
                      href="mailto:domination@thompsondigital.org"
                      className="text-sm hover:underline"
                    >
                      domination@thompsondigital.org
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-phone-line text-xl mr-3"></i>
                    <a href="tel:+17252756972" className="text-sm hover:underline">
                      +1 (725) 275-6972
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-map-pin-line text-xl mr-3"></i>
                    <span className="text-sm">8025 Tank Loop St, Las Vegas, NV 89166</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
